import { render, staticRenderFns } from "./Modernizacion.vue?vue&type=template&id=5b3c85fc&scoped=true&"
var script = {}
import style0 from "./Modernizacion.vue?vue&type=style&index=0&id=5b3c85fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c85fc",
  null
  
)

export default component.exports